import { Component, computed, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe, NgClass } from '@angular/common';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { MsisdnPreviewComponent } from '../../../shared/components/msisdn-preview/msisdn-preview.component';
import { filter, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { getLinkNavigationList } from '@core/const/const';
import { isParentLinkMatch } from '@core/helpers';
import { generalFeature } from '@src/state/general';
import { ProductType } from '@core/contracts/data-contracts';

@Component({
  selector: 'sc-sidebar',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslatePipe,
    AsyncPipe,
    SvgComponent,
    MsisdnPreviewComponent,
    NgClass,
  ],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  public currentPath = signal<string | null>(null);
  public isLimited = this.store.selectSignal(userFeature.selectIsMsisdnLimited);
  public isJottaInUse = this.store.selectSignal(userFeature.selectIsJottaInUse);
  public isTerminated = this.store.selectSignal(userFeature.selectIsTerminated);
  public isDataOnly = this.store.selectSignal(generalFeature.selectIsDataOnly);
  public isB2B = this.store.selectSignal(userFeature.selectIsB2B);
  public activeProduct = this.store.selectSignal(userFeature.selectActiveProduct);

  public isInternet = computed(() => this.activeProduct() === ProductType.Internet);

  public linkNavigationList = computed(() => {
    return getLinkNavigationList(
      this.isLimited(),
      this.isTerminated(),
      this.isJottaInUse(),
      this.isDataOnly(),
      this.isB2B(),
      this.isInternet()
    );

    // if (this.isLimited() && this.isJottaInUse()) {
    //   return [
    //     ...linkNavigationListLimited,
    //     {
    //       label: 'navigation.cloudStorage',
    //       path: AppRouting.CloudStorage,
    //       notLimited: true,
    //       subLinks: [],
    //     },
    //   ];
    // }

    // if (this.isLimited()) {
    //   return linkNavigationListLimited;
    // }

    // return linkNavigationList;
  });

  constructor(
    private readonly router: Router,
    private readonly store: Store
  ) { }

  public isSubLinkActive(linkGroup: { path: string; subLinks: { path: string }[] }): boolean {
    const current = this.currentPath();
    if (!current) return false;

    return (
      current === linkGroup.path ||
      linkGroup.subLinks.some((sublink) => current.startsWith(sublink.path))
    );
  }

  public isParentLinkActive(linkGroup: any): boolean {
    return isParentLinkMatch(this.currentPath(), linkGroup);
  }

  updatePath(path: string) {
    this.currentPath.set(this.currentPath() === path ? null : path);
  }

  public ngOnInit() {
    this.currentPath.set(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(
        tap((event) => {
          this.currentPath.set(event.urlAfterRedirects);

          window.scrollTo(0, 0);
        })
      )
      .subscribe();
  }
}
